<template>
  <!--  -->
  <div class="d-flex flex-column">
    <!-- dataTable -->
    <div class="d-flex flex-row flex-wrap justify-content-start mb-2">
      <!-- Cuerpo [Tabs] -->
      <div class="w-100 h">
        <div
          v-if="loadingServiciosTransbordos"
          class="w-100 mt-4 d-flex justify-content-center align-items-center"
        >
          <Loading />
        </div>

        <ui-tabs fullwidth v-else-if="dataAux.length">
          <ui-tab
            v-for="(item, index) in dataAux"
            :key="index"
            :title="item.name"
            @select="cambiarTabSeleccionada(index)"
          >
            <!-- Contenedor -->
            <div
              class="d-flex justify-content-between"
              style="min-height: 50px"
              v-if="!loadingTransbordosTabs"
            >
              <!-- Botones editar -->
              <div class="d-flex justify-content-start">
                <ui-textbox
                  v-if="mostrarTextboxEditar"
                  placeholder="Nombre transbordo 1"
                  v-model="item.name"
                  error="Campo requerido(*)"
                  :invalid="item.name.length == 0"
                ></ui-textbox>

                <Button
                  v-if="mostrarTextboxEditar"
                  class="ml-2"
                  icon="fas fa-check"
                  color="#208e09"
                  :width="30"
                  colorText="#ffffff"
                  tooltip="Guardar nombre de transbordo"
                  round
                  traslate
                  @click.native="guardarNombreTransbordo(index)"
                />
              </div>

              <!-- Botones de acciones -->
              <div class="d-flex justify-content-end">
                <ui-select
                  placeholder="Seleccionar puerto"
                  :options="puertos"
                  hasSearch
                  searchPlaceholder="Buscar"
                  v-model="puertoSeleccionadoModel"
                  :keys="{ value: 'id', label: 'name' }"
                >
                </ui-select>

                <!-- Boton agregar puerto -->
                <Button
                  class="ml-2 mr-4"
                  icon="fas fa-plus"
                  color="#208e09"
                  :width="30"
                  colorText="#ffffff"
                  tooltip="Agregar puerto de transbordo"
                  round
                  traslate
                  @click.native="agregarPuertoLista(index)"
                />

                <!-- Boton actualizar puerto -->
                <Button
                  icon="fas fa-pen"
                  color="#f69e14"
                  :width="30"
                  colorText="#ffffff"
                  tooltip="Actualizar nombre de transbordo"
                  round
                  traslate
                  @click.native="editarNombreTransbordo(index)"
                />

                <!-- Boton eliminar puerto -->
                <Button
                  class="ml-1"
                  icon="far fa-trash-alt"
                  color="#d51616"
                  :width="30"
                  colorText="#ffffff"
                  :tooltip="
                    'Eliminar transbordo ' + item.name + ' y todo su contenido'
                  "
                  round
                  traslate
                  @click.native="eliminarTransbordo(index)"
                />
              </div>
            </div>
            <!-- Contenedor -->

            <!-- Data Table -->

            <div
              v-if="loadingTransbordosTabs"
              class="w-100 mt-4 d-flex justify-content-center align-items-center"
            >
              <Loading />
            </div>

            <data-table-actualizar-servicio-transbordo
              v-else
              :headers="headers"
              :data="dataAux[ index ].data"
              :acciones="acciones"
              :max="8"
              paginacion
              buscar
              :key="index"
              :idtabla="`actualizar_servicios_transbordos_${index}`"
              :seleccionar="obtenerFilaSeleccionada"
              :id_tab="index"
              :cambiarTabSeleccionada="cambiarTabSeleccionada"
              :transbordosParaBorrar="transbordosParaBorrar"
              :nombreServicio="nombreServicio"
              :idServicio="id"
            />

            
          </ui-tab>
        </ui-tabs>

        <div
          class="d-flex flex-column justify-content-center align-items-center p-5"
          v-else
        >
          <i class="far fa-chart-bar fa-6x" style="color: #b9b9b9"></i>
          <div style="color: #b9b9b9">Sin transbordos asociados</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

import { mapState, mapActions } from "vuex";

//import // getServiciosTransbordos,
// deleteServiciosTransbordos,
//"../../../constants/lineas";

// Keen UI
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";

// Botton
import Button from "../../../components/common/Button";

// Toast
import VueToastify from "vue-toastify";
import DataTableActualizarServicioTransbordo from "../../../components/dataTables/lineas/DataTableActualizarServicioTransbordo";
//import NotFoundTable from "../../../components/common/NotFoundTable.vue";
import {
  editarNombreTransbordo,
  listarPuertosTransbordo,
  eliminarTransbordo,
} from "../../../constants/lineas";
import Loading from "../../../components/common/loading.vue";

Vue.use(VueToastify);

export default {
  props: ["id", "dataTransbordos","nombreServicio"],
  data() {
    return {
      headers: [
        "Nombre",
        "Tiempo transito reefer",
        "Tiempo transito dry",
        "Acciones",
      ],
      acciones: [],
      transbordosParaBorrar: [],
      dataServiciosTransbordosActualizar: [],
      dataTableAux: [],
      idAux: this.id,
      dataAux: this.dataTransbordos,
      transbordos: [],
      mostrarTextboxEditar: false,
      puertoSeleccionadoModel: [],
      tabSeleccionada: 0,
      puertosList: [
        { id: 100, name: "puerto n° 1 " },
        { id: 101, name: "puerto n° 2 " },
        { id: 102, name: "puerto n° 3 " },
        { id: 103, name: "puerto n° 4 " },
        { id: 104, name: "puerto n° 5 " },
        { id: 105, name: "puerto n° 6 " },
      ],

      loadingTransbordosTabs: false,
    };
  },

  components: {
    UiTextbox,
    UiSelect,
    Button,
    UiTabs,
    UiTab,
    DataTableActualizarServicioTransbordo,
   // NotFoundTable,
    Loading,
  },

  computed: {
    ...mapState(["puertos", "loading", "loadingServiciosTransbordos"]),
    ...mapState("lineas", [
      "dataDatatableServiciosTransbordos",
      "dataServiciosTransbordosPuertos",
      "nuevoTransbordoAux",
    ]),
  },

  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar", "ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetVisibleModalEditarServicioTransbordo",
      "actionSetDataServiciosTransbordos",
    ]),

    // Obteneción de Depositos desde la BD
    async getDataServiciosTransbordos() {
      //this.transbordosParaBorrar = [] ;
      // let dataServiciosTransbordosDB = await getServiciosTransbordos(
      //   this.idAux
      // );
      // this.dataTableAux = dataServiciosTransbordosDB.data_table;
      // this.actionSetDataServiciosTransbordos(
      //   dataServiciosTransbordosDB.data_table
      // );
      // this.generarBotonesAcciones();
    },

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataAux[this.tabSeleccionada].data.map((item, index) => {
        me.acciones.push([
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });

      me.dataAux[this.tabSeleccionada].acciones = me.acciones;
      me.ActionSetLoadingTable(false);
    },

    obtenerFilaSeleccionada({ id, id_tab , accion }) {

      if ( accion == "Eliminar") {
        this.transbordosParaBorrar.push(
          this.dataAux[id_tab].data[id].data[0].id
        );

        this.dataAux[id_tab].data = this.dataAux[id_tab].data.filter((val, key) => key != id );
      }

    },

    async eliminarServicioTransbordo(id_tab, id_registro, registro_local) {
      if (!registro_local) {

        this.$vToastify.success(
          "El puerto fue quitado de la lista y eliminado de los registros",
          "¡Realizado!"
        );
      } else {
        this.$delete(this.dataAux[id_tab].data, id_registro);
        this.$vToastify.success(
          "El puerto fue quitado de la lista",
          "¡Realizado!"
        );
      }

      this.generarBotonesAcciones();

  
    },

    editarNombreTransbordo(id) {
      this.mostrarTextboxEditar = true;
      console.log(this.dataAux[id].name);
    },

    async guardarNombreTransbordo(id) {
      
      if (this.dataAux[id].name.length) {

        this.mostrarTextboxEditar = false;

        const form = {
          id: this.dataAux[id].id,
          name: this.dataAux[id].name,
        };

        const status = await editarNombreTransbordo(form);

        if (status) {
          this.$vToastify.success("Nombre editado con éxito", "¡Realizado!");
        } else {
          this.$vToastify.error(
            "Error al editar nombre, por favor intente más tarde.",
            "Lo sentimos"
          );
        }
        
      }

        
    },

    async eliminarTransbordo(id_tab) {
      let text = "";
      let cantidadPuertos = this.dataAux[id_tab].data.length;

      if (cantidadPuertos > 0) {
        text = `¿Desea eliminar '${this.dataAux[id_tab].name}'? <br /> Este contiene ${cantidadPuertos} puerto/s`;
      } else {
        text = `Desea eliminar '${this.dataAux[id_tab].name}'?`;
      }

      this.$vToastify
        .prompt({
          body: text,
          answers: { Si: true, No: false },
        })
        .then(async (respuesta) => {
          const id = parseInt(this.dataAux[id_tab].id);

          if (respuesta) {
            
            const response = await eliminarTransbordo(id, this.idAux);

            if (response) {
              this.$delete(this.dataAux, id_tab);

              this.$vToastify.success(
                "Transbordo eliminado con éxito",
                "¡Realizado!"
              );
            } else {
              this.$vToastify.error(
                "Error al eliminar transbordo.",
                "Lo sentimos"
              );
            }
          }
        });
    },

    agregarPuertoLista(id) {
      
      if (this.puertoSeleccionadoModel == "") return;

      if (this.dataAux[id].data.length > 0) {
        let validacion = false;

        this.dataAux[id].data.forEach((d) => {
          if (d.data[0].id == this.puertoSeleccionadoModel.id)
            validacion = true;
        });

        if (validacion) return;
      }

      this.dataAux[id].data.push({
        data: [this.puertoSeleccionadoModel, 0, 0,false],
        data_complementaria: {
          select_puerto: this.puertoSeleccionadoModel,
          registro_local: true,
        },
        accion: "NUEVO",
        transfer_id: this.dataAux[id].id,
        type: [
          { key: 0, type: "text" },
          { key: 1, type: "textbox" },
          { key: 2, type: "textbox" },
          { key: 3, type: "checkbox" },
        ],
      });

      this.puertoSeleccionadoModel = [];
      this.generarBotonesAcciones();
    },

    async cambiarTabSeleccionada(id) {
      // Activar loader
      this.loadingTransbordosTabs = true;

      this.tabSeleccionada = id;

      const transferId = parseInt(this.dataAux[id].id);
      const puertosTransbordo = await listarPuertosTransbordo(transferId);

      if (
        !puertosTransbordo ||
        puertosTransbordo.length === 0 ||
        puertosTransbordo === undefined
      ) {
        this.dataAux[id].data = [];
        this.loadingTransbordosTabs = false;
      }
      this.dataAux[id].data = puertosTransbordo.map((p) => ({
        data: [
          {
            id: p.id,
            name: p.name,
          },
          p.tt_reefer,
          p.tt_dry,
          (p.has_early_cutoff == 1)
        ],
        data_complementaria: {
          select_puerto: {
            id: p.id,
            name: p.name,
          },
          registro_local: false,
        },
        transfer_id: 0,
        accion: "ACTUALIZAR",
        type: [
          { key: 0, type: "text" },
          { key: 1, type: "textbox" },
          { key: 2, type: "textbox" },
          { key: 3, type: "checkbox" },
        ],
      }));

      this.loadingTransbordosTabs = false;

      this.generarBotonesAcciones();
    },
  },

  created() {
    this.getDataServiciosTransbordos();
    this.actualizarURL();
  },

  watch: {
    id: function (_new) {
      let me = this;
      if (_new) {
        me.idAux = _new;
        me.getDataServiciosTransbordos();
      }
    },

    dataDatatableServiciosTransbordos: function (_new) {
      let me = this;
      if (_new) {
        me.data = _new;
        me.data.fila = _new;
        // me.generarBotonesAcciones();
      }
    },

    dataServiciosTransbordosPuertos: function (_new) {
      let me = this;
      if (_new) {
        me.data = _new;
        me.data.fila = _new;
        // me.generarBotonesAcciones();
      }
    },

    dataTransbordos: function (_new) {
      _new && (this.dataAux = _new);
    },
  },
};
</script>

<style></style>
